<template>
  <base-modal
    dialog-max-width="70vw"
    :customShowDialg="customShowDialog"
    :title="title"
    :confirmEnabled="showConfirmBtn"
    :confirmButton="confirmButton"
    @close="$emit('close')"
    @confirmed="$emit('confirmed', value)"
  >
    <div slot="body" style="font-size: 16px">
      <v-text-field
        class="filename-input"
        ref="queryNameInputField"
        :value="value"
        v-on:input.native="$emit('input', $event.target.value)"
        :rules="[fileNameRules.checkMatch(exactMatch)]"
        :label="$t('modal.saveAs.fileNameLabel')"
      ></v-text-field>

      <display-files
        :queries="queries"
        :hasActionColumn="false"
        @confirm="(q) => handleFileClick(q)"
      ></display-files>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from '../modals/BaseModal'
import DisplayFiles from '../parts/DisplayFiles'

export default {
  name: 'saveAs-modal',
  props: ['title', 'saveAsName', 'newQueryName', 'value', 'queries', 'customShowDialog', 'confirmButton'],
  components: {
    BaseModal,
    DisplayFiles
  },
  data () {
    const fileOverwrittenWarningMessage = this.$t('modal.saveAs.fileOverwrittenWarning')
    return {
      userFileNames: [],
      fileNameRules: {
        checkMatch (matchValue) {
          return _ => !matchValue || fileOverwrittenWarningMessage
        }
      }
    }
  },
  created () {
    this.userFileNames = this.queries.map(el => {
      return el.name
    })
  },
  computed: {
    showConfirmBtn: function () {
      const regex = new RegExp('[A-Za-z0-9]+')
      return this.value !== '' && this.value !== null && regex.test(this.value)
    },
    matchingQueries: function () {
      if (this.queries === null) {
        return null
      }
      if (this.value === null || typeof this.value === 'undefined' || this.value.length <= 0) {
        return this.queries
      }
      if (typeof this.value === 'undefined') {
        return this.queries
      }
      const needle = this.value.toLowerCase()
      return this.queries.filter(q => {
        if (q.name !== null) {
          const haystack = q.name.toLowerCase()
          return haystack.substring(0, needle.length) === needle
        }
      })
    },
    exactMatch: function () {
      return this.value !== null &&
        typeof this.value !== 'undefined' &&
        this.matchingQueries &&
        this.matchingQueries.length >= 1 &&
        this.value === this.matchingQueries[0].name &&
        (this.queryId === null || this.queryId !== this.matchingQueries[0]._id)
    }
  },
  methods: {
    handleFileClick (q) {
      this.value = this.queries.find((el) => el._id === q).name
    }
  }
}
</script>

<style scoped>
.filename-input.error--text,
.filename-input .error--text {
  color: rgb(255, 152, 0) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mainMenu/SaveAsModal.vue